/**
 * For more features, changes etc .. ping me : @sms
 * Image Cropper module.
 * Requirements:
 * jv-img-cropper
 * jv-img-cropper-src (will be your ng-src value)
 * jv-img-cropper-aspectRatio (aspect ratio of image) : default : 1
 * you need the : lib/imageCropper/cropper.min.js file
 * you need the : lib/imageCropper/cropper.min.css file
 */

angular.module('jv.ImageCropper', [])
.directive('jvImgCropper', function(){
	return{
		require: 'ngModel',
		link: function(scope, elem, attr, ngModel){
			var cropperCreated = false;

			elem.off('error').on('error', function(){
			});

			elem.off('load').on('load', function(){
				if(!cropperCreated){
					createCropperObject();
				}
			});

			attr.$observe('jvImgCropperSrc', function(newVal){
				if(!cropperCreated){
					elem.attr('src', newVal);
				}else{
					elem.cropper('setImgSrc', newVal);
				}
			});

			var createCropperObject = function(){
				elem.cropper({
					aspectRatio: attr.jvImgCropperRatio || 1,
					done: function(data){
						scope.$apply(function() {
							ngModel.$setViewValue(data);
						});
					}
				});

				var $dragmove = $("#drag-move");

				elem.on("dragmove", function() {
					$dragmove.addClass("btn-info").siblings().removeClass("btn-info");
				});

				cropperCreated = true;
			};
		}
	};
});